import React, { Component } from 'react';
import { connect } from 'react-redux';
import ApplicationMessages from '../inAppMessages/ApplicationMessages';
import HighlightOnInAppMessage from '../inAppMessages/HighlightOninAppMessage';
import VATNUMBER_CONTROLLER from '../../controllers/vatNumbers';
import UploadPanel from '../upload/UploadPanel';
import Logger, {ALL_MESSAGES, LOG_LEVELS} from '../../utils/logger';
import LanguageStringResolver from '../fields/language/LanguageStringResolver'
import FormattedDate from '../fields/dates/FormattedDate';
import moment from 'moment';
import _ from 'underscore';

const FORM_NAME = 'SII_SETUP';
const log = new Logger(FORM_NAME, LOG_LEVELS.DEBUG);
const CERTIFICATE_NOT_PARSED = "CertificateValidationError01 ";
const INVALID_PASSWORD_ERROR = 'CertificateValidationError02';
const INVALID_EXPIRY_DATE_ERROR = 'CertificateValidationError03';
const INVALID_PASSWORD_FORMAT = 'CertificateValidationError04';
const NO_CERTIFICATE_PROVIDED = 'CertificateValidationError05';
const FILE_EXTENSION ='.pfx';
const paraStyle ={fontWeight: '500'};
const MAX_PASSWORD_LENGTH = 100;
const siiStartDateHelpText = "All relevant documents found in VAT Reporting with a date equal or later than this date will be sent to SII.";
const ssiStartDateDetailedHelpText = 'Invoices sent to SII with an earlier date will be reported as a simplified invoice and will have the type: “first semester of  2017 and other invoices prior to inclusion in SII”';
const ssiCertifatePaswordHelpTest ="Enter your certificate password and upload your certificate.";
export class SiiSetup extends Component {
    constructor(props) {
        super(props);

        this.state = { immediateFilingEnabled :this.props.fieldValues && this.props.fieldValues.immediateFilingEnabled || 0, 
                       regPrevioGGEEoREDEMEoCompetenciaEnabled : this.props.fieldValues && this.props.fieldValues.regPrevioGGEEoREDEMEoCompetenciaEnabled || 0,
                       esSiiCertificateThumbprint: this.props.fieldValues && this.props.fieldValues.esSiiCertificateThumbprint ,
                       esSiiCertificateThumbprintOnUpload:this.props.siiCertficateDetails && this.props.siiCertficateDetails.esSiiCertificateThumbprintOnUpload,
                       isSiiCertificateAlreadyPresent : (this.props.fieldValues && this.props.fieldValues.esSiiCertificateThumbprint)?true:false,
                       password :this.props.siiCertficateDetails && this.props.siiCertficateDetails.certificatePassword,
                       esSiiCertificateExpiryDate :this.props.siiCertficateDetails && this.props.siiCertficateDetails.esSiiCertificateExpiryDate
                       
                    }
        this.onEnterPassword = this.onEnterPassword.bind(this);
        this.onUploadRequest = this.onUploadRequest.bind(this);
        this.onClearUploadCertificateFields = this.onClearUploadCertificateFields.bind(this);
        this.onDeleteCertificate = this.onDeleteCertificate.bind(this);
        this.filesToBeSent = null;
    }
//Important Note : Whatever the transaction will be done on SIISetUp.jsx page ,its parent should get notified.
//Transaction include date change ,checkbox change ,upload certificate,clear certificate,delete certificate
//Which in turn parent will update fieldValues object. This is required for maintaining its updated state.
//onSiiFieldChangeHandler is taking care of it 
//On sibling tab click this component get re-initiated.

   componentWillUnmount(){
    log.clearAllDictionaryErrors();
    }

    UNSAFE_componentWillMount(){
        this.props.isSiiCertificatePresent(this.props.fieldValues.id, (response) => {
            if(response.thumbPrint){
                this.setState({isSiiCertificateAlreadyPresent :true, esSiiCertificateThumbprint :response.thumbPrint});
            }else{
                this.setState({isSiiCertificateAlreadyPresent :false,esSiiCertificateThumbprint :""});
            }
         }, (error) => {
           if(error){
                if(error.message){
                    log.setDictionaryMessage(ALL_MESSAGES.SII_CERTIFICATE_ERROR,error.message);
                }else{
                    log.setDictionaryMessage(ALL_MESSAGES.SII_CERTIFICATE_ERROR,"Error occured while retrieving exisiting certificate status.");
                }
            }
         });
    }

    onDeleteCertificate(){
         this.props.doDeleteCertificate(this.props.fieldValues.id, () => {
            this.setState({esSiiCertificateThumbprint :"",isSiiCertificateAlreadyPresent :false});
            this.props.onSiiFieldChangeHandler("esSiiCertificateThumbprint","",true);
         }, (error) => {
           if(error){
                if(error.message){
                    log.setDictionaryMessage(ALL_MESSAGES.SII_CERTIFICATE_ERROR,error.message);
                }else{
                    log.setDictionaryMessage(ALL_MESSAGES.SII_CERTIFICATE_ERROR,"Error occured during delete certificate.");
                }
            }
         });
    }

    onUploadRequest(filesToBeSent) {
        log.clearAllDictionaryErrors();

        if (!this.state.password) {
            log.setDictionaryMessage(ALL_MESSAGES.BLANK_SII_CERTIFICATE_PASSWORD);
            return;
        }

        this.props.doValidateCertificate(filesToBeSent[0], this.state.password, (response) => {
            let siiCertficateDetails ={
                filesToBeSent :filesToBeSent[0],
                esSiiCertificateThumbprintOnUpload :response.thumbPrint,
                esSiiCertificateExpiryDate :moment(response.expiryDate,'MM-DD-YYYY').format('YYYY-MM-DD'),
                certificatePassword :this.state.password,
                vatNumberId : this.props.fieldValues.id 
            }
            //Updating Local state
            this.setState({esSiiCertificateThumbprintOnUpload : response.thumbPrint ,esSiiCertificateExpiryDate : moment(response.expiryDate,'MM-DD-YYYY').format('YYYY-MM-DD')});
            log.setDictionaryMessage(ALL_MESSAGES.VALID_SII_CERTIFICATE);
           
            //Updating Parent State,this is important becuase when user click on SAVE VAT NUmber.it is present in Parent form
            //Parent form is VATNumberForm.jsx ,so it will take certificate related data from parent which is being updated by below statement
            this.props.onSiiCertificateUpload(siiCertficateDetails);
         }, (error) => {
             if(error){
                if(error.message){
                    if (error.message.indexOf(INVALID_PASSWORD_ERROR) >= 0){
                        log.setDictionaryMessage(ALL_MESSAGES.INVALID_SII_CERTIFICATE_PASSWORD);
                    }else if (error.message.indexOf(INVALID_EXPIRY_DATE_ERROR) >= 0){
                        log.setDictionaryMessage(ALL_MESSAGES.INVALID_SII_CERTIFICATE_EXPIRED);
                    }else if (error.message.indexOf(CERTIFICATE_NOT_PARSED) >= 0){
                        log.setDictionaryMessage(ALL_MESSAGES.SII_CERTIFICATE_NOT_PARSED);
                    }else if (error.message.indexOf(INVALID_PASSWORD_FORMAT) >= 0){
                        log.setDictionaryMessage(ALL_MESSAGES.INVALID_SII_CERTIFICATE_PASSWORD_FORMAT);
                    }else if (error.message.indexOf(NO_CERTIFICATE_PROVIDED) >= 0){
                        log.setDictionaryMessage(ALL_MESSAGES.NO_SII_CERTIFICATE_PROVIDED);
                    }else if (error.message.indexOf("ValidationError01") >= 0) {
                        log.setDictionaryMessage(ALL_MESSAGES.FILE_IMPORT_ERROR_EXTENSION_FORBIDDEN);
                    }else if (error.message.indexOf("ValidationError02") >= 0) {
                        log.setDictionaryMessage(ALL_MESSAGES.FILE_IMPORT_ERROR_EXTENSION_TOO_LONG);
                    }else if (error.message.indexOf("ValidationError03") >= 0) {
                        log.setDictionaryMessage(ALL_MESSAGES.FILE_IMPORT_ERROR_FILENAME_TOO_LONG);
                    }else if (error.message.indexOf("ValidationError04") >= 0) {
                        log.setDictionaryMessage(ALL_MESSAGES.FILE_IMPORT_ERROR_FILENAME_FORBIDDEN);
                    }else if (error.message.indexOf("ValidationError05") >= 0) {
                        log.setDictionaryMessage(ALL_MESSAGES.FILE_IMPORT_ERROR_CONTENTTYPE_FORBIDDEN);
                    }else if (error.message.indexOf("ValidationError06") >= 0) {
                        log.setDictionaryMessage(ALL_MESSAGES.FILE_IMPORT_ERROR_CONTENTTYPE_MISMATCH);
                    }else{
                        log.setDictionaryMessage(ALL_MESSAGES.SII_CERTIFICATE_ERROR,error.message);
                    }
                 }
             } 
         });
    }
    onClearUploadCertificateFields(){
        log.clearAllDictionaryErrors();
        this.setState({esSiiCertificateThumbprintOnUpload : "" ,esSiiCertificateExpiryDate : "",password:""});
        this.props.onSiiCertificateClear()
    }

    onEnterPassword() {
        return (evt) => {
            if(!_.isEmpty(evt.target.value)){
                log.clearDictionaryError(ALL_MESSAGES.BLANK_SII_CERTIFICATE_PASSWORD);
                if(evt.target.value.length <= MAX_PASSWORD_LENGTH){
                    log.clearDictionaryError(ALL_MESSAGES.MAX_LENGTH_PASSWORD);
                }
                if(evt.target.value.length > MAX_PASSWORD_LENGTH){
                    log.setDictionaryMessage(ALL_MESSAGES.MAX_LENGTH_PASSWORD);
                    return;
                }
            }
            this.setState({ password: evt.target.value });
            this.props.onSiiFieldChangeHandler("password",evt.target.value);
        };
    }
   
    onCheckboxClickHandler(event){
        let property = event.target.name;
        let checkedStatus = (event.target.checked) ? 1:0;
        this.setState({ [property]: checkedStatus});
        if(property === "immediateFilingEnabled" && checkedStatus === 0){
            this.onClearUploadCertificateFields();
        }
         this.props.onSiiFieldChangeHandler(property,checkedStatus);
        
    }

//Important Note : Whatever the transaction will be done on SIISetUp.jsx page ,its parent should get notified.
//Transaction include date change ,checkbox change ,upload certificate,clear certificate,delete certificate
//Which in turn parent will update fieldValues object. This is required for maintaining its updated state.
//onSiiFieldChangeHandler is taking care of it 
//On sibling tab click this component get re-initiated.

 dateChangeHandlerFactory(fieldName){
        return (event) => {
            this.props.onSiiFieldChangeHandler(fieldName,event);
        };
    }
    trimDateFromDateTime(inputDateTime){
        if(inputDateTime && inputDateTime.length > 9){
            return inputDateTime.slice(0,10);
        }
        return inputDateTime;
    }

    render() {
      let existingfilesToBeSent = (this.props.siiCertficateDetails && this.props.siiCertficateDetails.filesToBeSent) ? [this.props.siiCertficateDetails.filesToBeSent]:[];
        return (
            <div>
                <ApplicationMessages
                    messageIds={[ ALL_MESSAGES.INVALID_SII_CERTIFICATE,
                                  ALL_MESSAGES.INVALID_SII_CERTIFICATE_PASSWORD, 
                                  ALL_MESSAGES.INVALID_SII_CERTIFICATE_EXPIRED, 
                                  ALL_MESSAGES.BLANK_SII_CERTIFICATE_PASSWORD ,
                                  ALL_MESSAGES.SII_CERTIFICATE_ERROR,
                                  ALL_MESSAGES.INVALID_SII_CERTIFICATE_PASSWORD_FORMAT,
                                  ALL_MESSAGES.SII_CERTIFICATE_NOT_PARSED,
                                  ALL_MESSAGES.NO_SII_CERTIFICATE_PROVIDED,
                                  ALL_MESSAGES.FILE_IMPORT_ERROR_EXTENSION_FORBIDDEN,
                                  ALL_MESSAGES.FILE_IMPORT_ERROR_EXTENSION_TOO_LONG,
                                  ALL_MESSAGES.FILE_IMPORT_ERROR_FILENAME_TOO_LONG,
                                  ALL_MESSAGES.FILE_IMPORT_ERROR_FILENAME_FORBIDDEN,
                                  ALL_MESSAGES.FILE_IMPORT_ERROR_CONTENTTYPE_FORBIDDEN,
                                  ALL_MESSAGES.FILE_IMPORT_ERROR_CONTENTTYPE_MISMATCH,
                                  ALL_MESSAGES.MAX_LENGTH_PASSWORD
                                ]}
                    messageType="applicationError"
                />
                <ApplicationMessages
                    messageIds={[ALL_MESSAGES.VALID_SII_CERTIFICATE]}
                    messageType="applicationSuccess"
                />

                <h3 className = "mb5"><LanguageStringResolver string='vrn_SIICertficateSetUpText'/></h3>
                <br/>
                <s-row >
                    <s-col span="6">
                        <fieldset>
                            <legend><LanguageStringResolver string='vrn_enableVATNumberforSII'/></legend>
                            <input
                                className="checkbox"
                                type="checkbox"
                                name ="immediateFilingEnabled"
                                checked ={this.state.immediateFilingEnabled === 1} 
                                onClick={this.onCheckboxClickHandler.bind(this)}
                            />
                            <label className="checkbox"><LanguageStringResolver string='vrn_enableSII'/></label>
                        </fieldset>
                        <fieldset className="margin-top-sm margin-bottom-sm">
                            
                                <label><LanguageStringResolver string='vrn_SIIStartDate'/></label>
                                <s-box><p style ={paraStyle}>{siiStartDateHelpText}</p></s-box>
                                <br/>
                                <FormattedDate
                                    editOptions={{
                                        fieldName: 'esSiiStartDate',
                                        changeHandler: this.dateChangeHandlerFactory('esSiiStartDate').bind(this)
                                    }}
                                    value = {this.trimDateFromDateTime(this.props.fieldValues.esSiiStartDate)}
                                    disabled = {!this.state.immediateFilingEnabled}
                                />
                        </fieldset>
                        <fieldset className="margin-top-sm margin-bottom-sm">
                                <label><LanguageStringResolver string='vrn_SIIStartDateDetailedInvoice'/></label>
                                <s-box><p style ={paraStyle}>{ssiStartDateDetailedHelpText}</p></s-box>
                                <br/>
                               <FormattedDate
                                    editOptions={{
                                        fieldName: 'essiiFullStartDate',
                                        changeHandler: this.dateChangeHandlerFactory('essiiFullStartDate').bind(this)
                                    }}
                                    value = {this.trimDateFromDateTime(this.props.fieldValues.essiiFullStartDate)}
                                    disabled = {!this.state.immediateFilingEnabled}
                                />
                        </fieldset>
                        <br/>
                        <h3 className ="mb5"><LanguageStringResolver string='vrn_regPrevioGGEEoREDEMEoCompetenciaText'/></h3>
                        <br/>
                        <fieldset>
                                <legend><LanguageStringResolver string='vrn_enableVATNumberforSIIRegPrevio'/></legend>
                                <input
                                    className="checkbox"
                                    type="checkbox"
                                    name = "regPrevioGGEEoREDEMEoCompetenciaEnabled"
                                    checked ={this.state.regPrevioGGEEoREDEMEoCompetenciaEnabled === 1}
                                    disabled = {!this.state.immediateFilingEnabled}
                                    onClick={this.onCheckboxClickHandler.bind(this)}
                                />
                                <label className="checkbox"><LanguageStringResolver string='vrn_enableSII'/>
                                </label>
                        </fieldset>
                        <fieldset className="margin-top-sm margin-bottom-sm">
                                    <label><LanguageStringResolver string='vrn_regPrevioGGEEoREDEMEoCompetenciaStartDate'/></label>
                                <FormattedDate
                                    editOptions={{
                                        fieldName: 'regPrevioGGEEoREDEMEoCompetenciaStartDate',
                                        changeHandler: this.dateChangeHandlerFactory('regPrevioGGEEoREDEMEoCompetenciaStartDate').bind(this)
                                    }}
                                    value = {this.trimDateFromDateTime(this.props.fieldValues.regPrevioGGEEoREDEMEoCompetenciaStartDate)}
                                    disabled = {! (this.state.immediateFilingEnabled && this.state.regPrevioGGEEoREDEMEoCompetenciaEnabled)}
                                />
                        </fieldset>
                        <HighlightOnInAppMessage
                            scopes={[FORM_NAME]}
                            messageIds={[ALL_MESSAGES.SII_ENDDATE_VALIDATION_ERROR]}>
                            <fieldset className="margin-top-sm margin-bottom-sm">
                                <label><LanguageStringResolver string='vrn_regPrevioGGEEoREDEMEoCompetenciaEndDate'/></label>
                               <FormattedDate
                                    editOptions={{
                                        fieldName: 'regPrevioGGEEoREDEMEoCompetenciaEndDate',
                                        changeHandler: this.dateChangeHandlerFactory('regPrevioGGEEoREDEMEoCompetenciaEndDate').bind(this)
                                    }}
                                    value = {this.trimDateFromDateTime(this.props.fieldValues.regPrevioGGEEoREDEMEoCompetenciaEndDate)}
                                    disabled = {! (this.state.immediateFilingEnabled && this.state.regPrevioGGEEoREDEMEoCompetenciaEnabled)}
                                />
                            </fieldset>
                        </HighlightOnInAppMessage>
                        <br/>
                        <s-box>
                            <p style ={paraStyle}>
                                Sending invoices was difficult during this time because of one of the three following reasons:<br/>
                                    a)	The company wasn’t aware that they were a Large Company (they had a turnover above 6,010,121.04 euros)<br/>
                                    b)	The Tax Administration/Inspection Authority to who they report to changed; or<br/>
                                    c)	The company’s application for the monthly refund regime (REDEME in Spanish) was after the first day that the registration took effect.<br/>
                            </p>
                        </s-box>
                     
                    </s-col>
                    <s-col span="6">
                        {(!this.state.isSiiCertificateAlreadyPresent) ?<div>
                                <HighlightOnInAppMessage
                                    scopes={[FORM_NAME]}
                                    messageIds={[ALL_MESSAGES.BLANK_SII_CERTIFICATE_PASSWORD,ALL_MESSAGES.MAX_LENGTH_PASSWORD]}>
                                    <fieldset className="margin-top-sm margin-bottom-sm">
                                        <label><LanguageStringResolver string='vrn_SIICerftificatePassword'/></label>
                                        <s-box><p style ={paraStyle}>{ssiCertifatePaswordHelpTest}</p></s-box><br/>
                                        <input
                                            type="password"
                                            onChange={this.onEnterPassword()}
                                            value={this.state.password} 
                                            disabled = {!this.state.immediateFilingEnabled || this.state.esSiiCertificateThumbprintOnUpload }
                                        />
                                    </fieldset>
                                </HighlightOnInAppMessage>
                                <fieldset>
                                    <label><LanguageStringResolver string='vrn_SIICertThumbprint'/></label>
                                    <input type="text" 
                                            value={this.state.esSiiCertificateThumbprintOnUpload} 
                                            disabled />
                                </fieldset>
                                <fieldset>
                                    <label><LanguageStringResolver string='vrn_SIISExpiryDate'/></label>
                                    <input type="date" 
                                            value={this.state.esSiiCertificateExpiryDate} 
                                            disabled />
                                </fieldset>
                                <fieldset>
                                    <label className="mt10"><LanguageStringResolver string='submitFilingDE_Certificate'/>:</label>
                                    <UploadPanel
                                            uploadLimit={1}
                                            acceptTypes={[FILE_EXTENSION]}
                                            onUploadRequest={this.onUploadRequest}
                                            onClearFiles = {this.onClearUploadCertificateFields}
                                            clearSelection={false}
                                            disabled = {!this.state.immediateFilingEnabled || this.state.esSiiCertificateThumbprintOnUpload}
                                            loadExistingFile = {existingfilesToBeSent}
                                        />
                                </fieldset>
                                <s-box>
                                    <h2><LanguageStringResolver string='uploadInformation'/></h2>
                                    <LanguageStringResolver string='acceptedFormats'/>
                                        <span className="semi-bold">
                                            <LanguageStringResolver string={FILE_EXTENSION}/>
                                        </span>
                                    <br/>
                                    <LanguageStringResolver string='transactionAttachment_maxFileSizeInMB'/>:
                                        <span>{`200 MB`}</span>
                                </s-box>
                                </div>:<div>
                                        <fieldset>
                                            <label><LanguageStringResolver string='vrn_SIICertThumbprint'/></label>
                                            <input type="text" value= {this.state.esSiiCertificateThumbprint} disabled />
                                        </fieldset>
                                        <button className="secondary mt15" onClick = {this.onDeleteCertificate} ><LanguageStringResolver string='vrn_deleteSIICertificate'/></button>
                                    </div>}
                    </s-col> 
                </s-row>
            </div>
        )
    }
}

SiiSetup.defaultProps = {	
    siiCertficateDetails :null
}
function mapStateToProps(state, props) {
    return { };
}

function mapDispatchersToProps(dispatch) {
    return {
        doValidateCertificate: (certificateFile, password, validHandler, invalidHandler) => {
            dispatch(VATNUMBER_CONTROLLER.doValidateSiiCertificate(certificateFile, password, (response) => {
                validHandler(response);
            }, (error) => {
                invalidHandler(error);
            }));
        },
        doDeleteCertificate: (VatNumberID, validHandler, invalidHandler) => {
            dispatch(VATNUMBER_CONTROLLER.doDeleteSiiCertificate(VatNumberID, (response) => {
                validHandler(response);
            }, (error) => {
                invalidHandler(error);
            }));
        },
        isSiiCertificatePresent: (VatNumberID, validHandler, invalidHandler) => {
            dispatch(VATNUMBER_CONTROLLER.isSiiCertificatePresent(VatNumberID, (response) => {
                validHandler(response);
            }, (error) => {
                invalidHandler(error);
            }));
        }
        
    }
}

export default connect(mapStateToProps, mapDispatchersToProps)(SiiSetup);
